import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import React__default, { forwardRef, useId } from 'react';
import { Slot } from '@radix-ui/react-slot';
import styles from './Grid.styles.esm.js';

const Grid = forwardRef((props, forwardedRef) => {
    const generatedId = useId();
    const { id = generatedId, className, asChild = false, columns, gap, rows, children } = props, otherProps = __rest(props, ["id", "className", "asChild", "columns", "gap", "rows", "children"]);
    const Comp = asChild ? Slot : "div";
    const styleOptions = {
        xsCols: typeof columns === "number" ? columns : columns === null || columns === void 0 ? void 0 : columns.xs,
        smCols: typeof columns !== "number" ? columns === null || columns === void 0 ? void 0 : columns.sm : undefined,
        mdCols: typeof columns !== "number" ? columns === null || columns === void 0 ? void 0 : columns.md : undefined,
        lgCols: typeof columns !== "number" ? columns === null || columns === void 0 ? void 0 : columns.lg : undefined,
        xsGap: typeof gap === "number" ? gap : gap === null || gap === void 0 ? void 0 : gap.xs,
        smGap: typeof gap !== "number" ? gap === null || gap === void 0 ? void 0 : gap.sm : undefined,
        mdGap: typeof gap !== "number" ? gap === null || gap === void 0 ? void 0 : gap.md : undefined,
        lgGap: typeof gap !== "number" ? gap === null || gap === void 0 ? void 0 : gap.lg : undefined,
        xsRows: typeof rows === "number" ? rows : rows === null || rows === void 0 ? void 0 : rows.xs,
        smRows: typeof rows !== "number" ? rows === null || rows === void 0 ? void 0 : rows.sm : undefined,
        mdRows: typeof rows !== "number" ? rows === null || rows === void 0 ? void 0 : rows.md : undefined,
        lgRows: typeof rows !== "number" ? rows === null || rows === void 0 ? void 0 : rows.lg : undefined,
        class: className,
    };
    const classNames = styles(styleOptions);
    // Automatically add keys to children if they are an array
    const processedChildren = React__default.Children.map(children, (child, index) => {
        if (React__default.isValidElement(child) && child.key === null) {
            return React__default.cloneElement(child, { key: `grid-child-${id}-${index}` });
        }
        return child;
    });
    return (jsx(Comp, Object.assign({ id: id, ref: forwardedRef, className: classNames }, otherProps, { children: processedChildren })));
});
Grid.displayName = "Grid";

export { Grid };
